import { render, staticRenderFns } from "./MyClientsSummary.vue?vue&type=template&id=01ba37b3"
import script from "./MyClientsSummary.vue?vue&type=script&lang=js"
export * from "./MyClientsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports